module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ed-Gb.d2e4d124.png";